import React from 'react';

const Style = {
    marginTop:"50px"
}

const Footer = () => {
    return (
        <div>
            <footer style={Style} className="bg-dark text-white">
                <div className="text-center">
                    <small>Copyright &copy; The New College</small>
                </div>
            </footer>
        </div>
    );
}



export default Footer;